import Component from '../core/Component';

export default class NotificationOpener extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            origin: null
        }
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick);
    }

    handleClick(event) {
        event.preventDefault();

        const target = document.getElementById(this.element.getAttribute('href').replace('#', ''));

        if (!target) {
            return;
        }

        const layer = Component.getFromElement(target);

        const origin = this.ref.origin || this.element;

        if (layer) {
            layer.open(origin);
        }

        let dataUrl = this.element.dataset.url;

        $.nette.ajax({
            url: dataUrl,
            type: 'POST'
        });
    }
}